/**
 * Leituras da visao geral que ainda nao existem no backend.
 *
 * Decisoes nao obvias:
 *  1. `companyId` entra na assinatura mas NAO viaja na query. O tenant vem da
 *     sessao (cookie), como em todo `lib/api.ts`; o parametro existe para o
 *     gerador simulado variar os numeros por empresa e para o `useCallback`
 *     da pagina refazer a busca quando a administracao troca a empresa em
 *     foco. Em modo real, ate a rota nascer, as chamadas caem em `ErrorPanel`
 *     (404) -- nunca em numero inventado.
 *  2. O retrato "Agora" tem rota propria (`/api/engine/now`) porque muda a
 *     cada segundo e nao depende do periodo: juntar com o resumo faria a rota
 *     mais pesada do painel rodar a cada 15 s por causa de tres contadores.
 */

import { fetchOrSimulate, rangeQuery, type Envelope } from '../../lib/api';
import { equipeDaEmpresa } from '../../lib/mock/catalogo';
import type { PeriodRange, TeamMember } from '../../types';
import { simularAgora, simularResumoFunis } from './mock';
import type { FunnelsSummary, LiveSnapshot } from './types';

/** Metricas por funil, canal e oferta na janela, com o periodo anterior. Rota futura: GET /api/funnels/summary. */
export function fetchResumoFunis(companyId: string, range: PeriodRange, signal: AbortSignal): Promise<Envelope<FunnelsSummary>> {
  return fetchOrSimulate('/api/funnels/summary', rangeQuery(range), signal, () => simularResumoFunis(companyId, range));
}

/** Equipe da empresa, para o seletor de responsavel. Rota futura: GET /api/team. */
export function fetchEquipe(companyId: string, signal: AbortSignal): Promise<Envelope<readonly TeamMember[]>> {
  return fetchOrSimulate('/api/team', {}, signal, () => equipeDaEmpresa(companyId));
}

/** Retrato do motor neste instante (fila, ligacoes, respostas). Rota futura: GET /api/engine/now. */
export function fetchAgora(companyId: string, signal: AbortSignal): Promise<Envelope<LiveSnapshot>> {
  return fetchOrSimulate('/api/engine/now', {}, signal, () => simularAgora(companyId));
}
